import React, { useState } from "react";
import contactImg1 from "../../assets/images/shapes/contact-1-shape-2.png";
import contactImg2 from "../../assets/images/new/4.jpg";
import contactImg3 from "../../assets/images/new/2.jpg";
import contactImg4 from "../../assets/images/new/conatus us.png";
import contactImg5 from "../../assets/images/shapes/about-1-shape-2.png";
import contactImg6 from "../../assets/images/shapes/about-1-shape-3.png";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import GoogleMap from "../../Components/GoogleMapModal";
import ContactUsImg from "../../assets/images/new/ContactUsImg.png";
import ContactUS from "../../assets/images/new/aboutUsImage.png";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { Helmet } from "react-helmet-async";
import { ContactUSApi } from "../../ApiServices/NewsLettter/NewsLetterApi";
import SuccessModal from "../../Components/SuccessModal";
import { useNavigate } from "react-router-dom";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";

const ContactPage = () => {
  const [Action, setAction] = useState([]);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const navigate = useNavigate();
  const [contactData, setContactData] = useState({
    FirstName: null,
    LasteName: null,
    Email: null,
    PhoneNo: null,
    Message: null,
  });
  const [contactUsMsg, setContactUsMsg] = useState(false);
  const [error, setError] = useState(false);
  const [verified, setVerified] = useState(null);

  function onCaptchaChange(value) {
    console.log("Captcha value:", value);
    setVerified(true);
  }

  const handleContactFormSubmit = () => {

    let isValid = false;
    if (
      contactData.FirstName === "" ||
      contactData.FirstName === undefined ||
      contactData.FirstName === null ||
      contactData.LasteName === "" ||
      contactData.LasteName === "" ||
      contactData.LasteName === "" ||
      contactData.PhoneNo === "" ||
      contactData.PhoneNo === undefined ||
      contactData.PhoneNo === null ||
      contactData?.PhoneNo?.length !== 10 ||
      contactData.Message === "" ||
      contactData.Message === undefined ||
      contactData.Message === null ||
      contactData.Email === "" ||
      contactData.Email === undefined ||
      contactData.Email === null
    ) {
      isValid = true;
      setError(true);
    } else if (
      contactData.Email !== null &&
      !validateEmail(contactData.Email)
    ) {
      isValid = true;
      setError(true);
    }

    const api_params = {
      FirstName: contactData.FirstName,
      LasteName: contactData.LasteName,
      Email: contactData.Email,
      PhoneNo: contactData.PhoneNo,
      Message: contactData.Message,
    };

    if (!isValid) {
      ContactUsAPI(api_params);
    }
  };
  console.log(contactData, "3ddddddddddsa");

  const ContactUsAPI = async (api_params) => {
    // debugger
    try {
      const res = await ContactUSApi(api_params);

      if (res.ResponseMessage === "Success.") {
        // setContactUsMsg('Thank you for contacting us.')
        // setAction('Contact')
        // setShowSuccessPopUp(true);
        navigate("/thank-you", {
          state: { moduleName: "ContactUs" },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeAll = () => {
    // debugger;
    setShowSuccessPopUp(false);
    setInitialData();
  };

  const setInitialData = () => {
    setError(false);
    setContactData((prev) => ({
      ...prev,
      FirstName: "",
      LasteName: "",
      Email: "",
      PhoneNo: "",
      Message: "",
    }));
  };
  //   const ContactUsAPI = (params) => {
  //     const templateParams = {
  //       Name: params.name,
  //       Email: params.email,
  //       "Mobile Number": params.mobileNo,
  //       message: params.message,
  //       //   to_name: "Velvet Admin",
  //       //   from_name: "Velvet mail service",
  //       //   receiver_email: "velvetgps@gmail.com",
  //     };

  //     emailjs
  //       .send(
  //         "service_wp19bkh", // Service ID
  //         "template_b9wrsrm", // Template ID
  //         templateParams, // Template Parameters
  //         "e5YUU5XlmWckFjZk_" // Public Key
  //       )
  //       .then(
  //         () => {
  //           console.log("SUCCESS!");
  //           setShowThanksModal(true);
  //         },
  //         (error) => {
  //           console.log("FAILED...", error.text);
  //         }
  //       );
  //   };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  return (
    <>
      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">Contact Us</h2>
        </div>
      </section>

      <Helmet>
        <title>Contact Us for Spiritual Services - MyOmNamo</title>
        <meta
          name="description"
          content="Have questions or need assistance? Reach out to us for pandit booking, puja arrangements, and spiritual guidance. We’re here to help!"
        />
        <link rel="canonical" href="https://www.myomnamo.com/contact-us" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Contact Us for Spiritual Services - MyOmNamo"
        />
        <meta
          property="og:description"
          content="Have questions or need assistance? Reach out to us for pandit booking, puja arrangements, and spiritual guidance. We’re here to help!"
        />
        <meta
          property="og:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />
        <meta property="og:url" content="https://www.myomnamo.com/contact-us" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="MyOmNamo" />
        <meta property="og:locale" content="en_IN" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Us for Spiritual Services - MyOmNamo"
        />
        <meta
          name="twitter:description"
          content="Have questions or need assistance? Reach out to us for pandit booking, puja arrangements, and spiritual guidance. We’re here to help!"
        />
        <meta
          name="twitter:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />
      </Helmet>

      <section
        className="contact-one contact-one--page"
        style={{ padding: "25px 0 0 0" }}
      >
        <div
          className="contact-one__shape"
          style={{
            backgroundImage: `url("${contactImg1}")`,
          }}
        ></div>
        <div className="" style={{ display: "flex", flexDirection: "column" }}>
          <div className="row">
            <div className="col-xl-5">
              <div
                className="about-one__image wow fadeInLeft"
                data-wow-delay="100ms"
                style={{ padding: "0px" }}
              >
                <div className="about-one__image__one">
                  <img
                    src={ContactUS}
                    style={{
                      height: "490px",
                      width: "467px",
                      objectFit: "contain",
                    }}
                    alt="contact"
                  />
                </div>

                <div className="about-one__image__shape-one">
                  {/* <img src={contactImg4} alt="shape" /> */}
                </div>
                <div className="about-one__image__shape-two">
                  {/* <img src={contactImg5} alt="shape" /> */}
                </div>
                <div className="about-one__image__shape-three">
                  {/* <img src={contactImg6} alt="shape" /> */}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card-body" style={{ marginLeft: "12px" }}>
                <h6 className="sec-title__tagline bw-split-in-right">
                  <img className=" tagline-img" src={batuk} alt="" />
                  Get in Touch with Us
                </h6>
                <h3 className="sec-title__title bw-split-in-left">
                  Let’s Talk! Contact Us Today
                </h3>
                <p className="contact-one__text">
                  We’re here to answer any questions you have and help you get
                  started on your spiritual journey. Reach out and let’s
                  connect!{" "}
                </p>
                <div className="row gy-3">
                  <div className="col-md-6">
                    <label className="form-label fw-light">
                      First Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      placeholder="Enter First Name"
                      value={contactData.FirstName}
                      onChange={(e) => {
                        let inputValue = e.target.value;

                        // Remove spaces completely
                        inputValue = inputValue.replace(/\s/g, "");

                        // Capitalize the first letter
                        if (inputValue?.length > 0) {
                          inputValue =
                            inputValue.charAt(0).toUpperCase() +
                            inputValue.slice(1);
                        }

                        setContactData((prev) => ({
                          ...prev,
                          FirstName: inputValue,
                        }));
                      }}
                    />
                    {(error && contactData.FirstName === null) ||
                      contactData.FirstName === undefined ||
                      contactData.FirstName === "" ? (
                      <span className="error-msg">{ERROR_MESSAGES}</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-light">
                      Last Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      placeholder="Enter Last Name"
                      value={contactData.LasteName}
                      onChange={(e) => {
                        let inputValue = e.target.value;

                        // Remove spaces completely
                        inputValue = inputValue.replace(/\s/g, "");

                        // Capitalize the first letter
                        if (inputValue?.length > 0) {
                          inputValue =
                            inputValue.charAt(0).toUpperCase() +
                            inputValue.slice(1);
                        }

                        setContactData((prev) => ({
                          ...prev,
                          LasteName: inputValue,
                        }));
                      }}
                    />
                    {(error && contactData.LasteName === null) ||
                      contactData.LasteName === undefined ||
                      contactData.LasteName === "" ? (
                      <span className="error-msg">{ERROR_MESSAGES}</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="row gy-3">
                  <div className="col-md-6">
                    <label className="form-label fw-light">
                      Mobile No. <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      maxLength={10}
                      placeholder="Enter Mobile No."
                      value={contactData.PhoneNo || ""}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                        setContactData((prev) => ({
                          ...prev,
                          PhoneNo: numericValue,
                        }));
                      }}
                    />
                    {error &&
                      (contactData.PhoneNo === "" ||
                        contactData?.PhoneNo === null ||
                        contactData?.PhoneNo === undefined) ? (
                      <span style={{ color: "red", fontSize: "15px" }}>
                        {ERROR_MESSAGES}
                      </span>
                    ) : error &&
                      contactData.PhoneNo?.length > 0 &&
                      contactData.PhoneNo?.length !== 10 ? (
                      <span style={{ color: "red", fontSize: "15px" }}>
                        Invalid Mobile Number
                      </span>
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-light">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-form-control rounded-3"
                      placeholder="Enter Email"
                      value={contactData.Email}
                      onChange={(e) => {
                        setError(false);
                        let InputValue = e.target.value;

                        if (InputValue.startsWith(" ")) {
                          InputValue = InputValue.trimStart(); // Remove leading space
                        }

                        setContactData((prev) => ({
                          ...prev,
                          Email: InputValue,
                        }));
                      }}
                    />
                    {error &&
                      (contactData.Email === null ||
                        contactData.Email === undefined ||
                        contactData.Email === "") ? (
                      <span
                        style={{
                          color: "red",
                          fontSize: "15px",
                        }}
                      >
                        {ERROR_MESSAGES}
                      </span>
                    ) : contactData.Email !== null &&
                      contactData.Email !== "" &&
                      !validateEmail(contactData.Email) ? (
                      <span style={{ color: "red", fontSize: "15px" }}>
                        Please enter a valid email
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="row gy-3" style={{ justifyContent: "left" }}>
                  <div className="col-md-12">
                    <label className="form-label fw-light">
                      Your Message <span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      className="custom-form-control"
                      rows="5"
                      style={{ height: "73px" }}
                      onChange={(e) => {
                        let inputValue = e.target.value;

                        // Prevent first character from being a space
                        if (inputValue.startsWith(" ")) {
                          inputValue = inputValue.trimStart();
                        }

                        // Replace multiple spaces with a single space
                        inputValue = inputValue.replace(/\s{2,}/g, " ");

                        // Allow only letters, numbers, and spaces
                        inputValue = inputValue.replace(/[^a-zA-Z0-9\s]/g, "");

                        setContactData((prev) => ({
                          ...prev,
                          Message: inputValue,
                        }));
                      }}
                      value={contactData.Message}
                      placeholder="Your Message*"
                      maxLength={200}
                    ></textarea>
                    {error &&
                      (contactData.Message === null ||
                        contactData.Message === undefined ||
                        contactData.Message === "") ? (
                      <span
                        style={{
                          color: "red",
                          fontSize: "15px",
                        }}
                      >
                        {ERROR_MESSAGES}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Submit Button */}
                <div className="d-flex justify-content-left mt-4">
                  <button
                    className="Normal-app-btn"
                    style={{ fontSize: "16px" }}
                    onClick={() => handleContactFormSubmit()}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div
              className="col-12 w-100"
              style={{ padding: "0px", marginTop: "5px" }}
            >
              <GoogleMap className="" />
            </div>
          </div>
          <DownloadApp />
        </div>
        <SuccessModal
          Action={"Contact"}
          show={showSuccessPopUp}
          onHide={() => setShowSuccessPopUp(false)}
          setContactUsMsg={setContactUsMsg}
          contactUsMsg={contactUsMsg}
          onConfirm={closeAll}
        // Action={Action}
        />
      </section>
    </>
  );
};

export default ContactPage;
